export default __webpack_public_path__ + "static/media/cp_geo_ar.6a7b7b25.svg";